"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsAgreeFinancialRequest = void 0;
var IsAgreeFinancialRequest = /** @class */ (function () {
    function IsAgreeFinancialRequest() {
    }
    return IsAgreeFinancialRequest;
}());
exports.IsAgreeFinancialRequest = IsAgreeFinancialRequest;
;
//# sourceMappingURL=isAgreeFinancial.request.js.map